import dayjs from "dayjs";

/**
 * Reverse chart series if needed.
 * @param {array} series
 */
export function reverseSeries(series) {
    if (series.length > 1 && dayjs(series[0].time).isAfter(dayjs(series[1].time))) {
        series.reverse();
    }

    return series;
}

export function utcTimestampToTimezoneTimestamp(timestamp) {
    const date = new Date(timestamp);

    return date.getTime() + Math.abs(date.getTimezoneOffset()) * 60000;
}

export function transformBarTimestampToLocalTimeZone(bar) {
    bar.time = Math.floor(
        utcTimestampToTimezoneTimestamp(bar.time * 1000) / 1000
    );
}

export function transformTimestampToLocalTimeZone(series) {
    if (series) {
        for (let i = 0, len1 = series.length; i < len1; i++) {
            transformBarTimestampToLocalTimeZone(series[i]);
        }
    }
}
